import MarkdownIt from "markdown-it";

export function videoPlugin(md) {
  md.inline.ruler.after('link', 'video', function (state, silent) {
    const videoRegex = /@\[(video)\]\((.*)\)/;
    const match = videoRegex.exec(state.src.slice(state.pos));

    if (match) {
      if (!silent) {
        const token = state.push('video', '', 0);
        token.attrs = { url: match[2] }; // Capture the URL part
      }
      state.pos += match[0].length; // Move the cursor after the matched string
      return true;
    }
    return false;
  });

  md.renderer.rules.video = function (tokens, idx) {
    const videoUrl = tokens[idx].attrs.url;

    // Check if it's a YouTube or Vimeo link and modify accordingly
    let embedUrl;
    if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
      // Handle YouTube URLs
      const youtubeId = videoUrl.includes('watch?v=')
        ? videoUrl.split('watch?v=')[1]
        : videoUrl.split('youtu.be/')[1];
      embedUrl = `https://www.youtube.com/embed/${youtubeId}`;
    } else if (videoUrl.includes('vimeo.com')) {
      // Handle Vimeo URLs
      const vimeoId = videoUrl.split('vimeo.com/')[1];
      embedUrl = `https://player.vimeo.com/video/${vimeoId}`;
    } else {
      // If it's not a supported video link, return a warning message in red text
      return `<p style="color: red;">Youtube or Vimeo plz</p>`;
      // return 'INVALID VIDEO URL. Please provide a valid YouTube or Vimeo link.';
    }

    // Return the embedded iframe
    return `<iframe style="width: 100%; height: auto; aspect-ratio: 16 / 9;" src="${embedUrl}" frameborder="0" allowfullscreen></iframe>`;
  };

  // Extend the link_open rule to add target="_blank" to all links
  const defaultLinkOpenRenderer = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options);
  };
  md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    // Add target="_blank" to all links
    const token = tokens[idx];
    const existingIndex = token.attrIndex('target');

    if (existingIndex < 0) {
      token.attrPush(['target', '_blank']); // Add new attribute
    } else {
      token.attrs[existingIndex][1] = '_blank'; // Replace existing value
    }

    return defaultLinkOpenRenderer(tokens, idx, options, env, self);
  };
}

export const md = new MarkdownIt();
md.use(videoPlugin);
